// TaskBadge — bell-icon in topbar met count van open taken voor de huidige
// user. Polling 60s. Klik → /taken (gefilterd op mij). Geen popup, gewoon
// direct navigeren.

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchTaskSummary, TaskSummary } from "../api/client";
import { useAuth } from "../context/AuthContext";

export function TaskBadge() {
  const { user, hasPerm } = useAuth();
  const navigate = useNavigate();
  const [summary, setSummary] = useState<TaskSummary | null>(null);

  useEffect(() => {
    if (!user || !hasPerm("tasks.read")) return;
    let active = true;
    const tick = () => fetchTaskSummary()
      .then((s) => { if (active) setSummary(s); })
      .catch(() => {});
    tick();
    const id = setInterval(tick, 60_000);
    const onVis = () => { if (document.visibilityState === "visible") tick(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { active = false; clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, [user, hasPerm]);

  if (!user || !hasPerm("tasks.read")) return null;
  const count = summary?.open_assigned ?? 0;

  return (
    <button
      onClick={() => navigate(`/taken?assignee_id=${user.id}&status=open`)}
      title={summary ? `${summary.open_assigned} open aan jou toegewezen · ${summary.open_created} door jou aangemaakt nog open` : "Mijn taken"}
      style={{
        position: "relative",
        background: "transparent", border: "none", padding: "4px 8px",
        cursor: "pointer", color: "var(--color-text)", fontSize: 18,
      }}
    >
      🔔
      {count > 0 && (
        <span style={{
          position: "absolute", top: 0, right: 0,
          background: "var(--color-negative, #ef4444)", color: "white",
          borderRadius: 10, padding: "0 5px", fontSize: 10, lineHeight: "14px",
          minWidth: 14, textAlign: "center", fontWeight: 600,
        }}>{count > 99 ? "99+" : count}</span>
      )}
    </button>
  );
}
